<template>
<div id="mirrorPreview" class="mirrorPreview" :class="{ 'is-modal': isBuyInShopModal || isMirrorMenuModal }">
  <MirrorHeader title="PREVIEW" />
  <h2 class="mirrorPreview__brand">
    <img :src="customItem.brandMainImage" :alt="customItem.brandName" />
  </h2>
  <div class="mirrorPreview__wrap">
    <swiper :options="swiperOption" class="mirrorPreview__wrap__swiper">
      <swiper-slide v-for="image in customItem.customImage" :key="image.filename" class="mirrorPreview__wrap__swiper__slide">
        <div class="mirrorPreview__wrap__swiper__slide__imgwrap"><img :src="image.filename" :alt="item.label" /></div>
      </swiper-slide>
      <div class="mirrorPreview__wrap__swiper__prev swiper-button-prev" slot="button-prev">
        <img src="@/assets/images/mirror/commons/commons-slideLeft.svg" alt="left" />
      </div>
      <div class="mirrorPreview__wrap__swiper__next swiper-button-next" slot="button-next">
        <img src="@/assets/images/mirror/commons/commons-slideRight.svg" alt="right" />
      </div>
    </swiper>
    <div @click="buyItem" class="mirrorPreview__wrap__startbtn">このカスタマイズを店頭で購入する</div>
    <h3 class="mirrorPreview__wrap__name">{{ item.name }}</h3>
    <p class="mirrorPreview__wrap__makerID" v-if="basePartsMakerID !== ''">品番: {{ basePartsMakerID }}</p>
    <p class="mirrorPreview__wrap__price">¥ {{ customItem.amount | formatPrice(item.tax) }}</p>
    <div class="mirrorPreview__wrap__flex">
      <div class="mirrorPreview__wrap__flex__box">
        <h4 class="mirrorPreview__wrap__flex__box__title">Information</h4>
        <table class="mirrorPreview__wrap__flex__box__table">
          <tr v-for="(info, index) in item.informations" :key="index">
            <th>{{ info.infoLabel }}</th>
            <td v-html="info.infoValue"></td>
          </tr>
        </table>
      </div>
      <div class="mirrorPreview__wrap__flex__box">
        <h4 class="mirrorPreview__wrap__flex__box__title">Customize</h4>
        <table class="mirrorPreview__wrap__flex__box__table">
          <tr v-for="(parts, index) in customItem.parts" :key="index">
            <th>{{ parts.label }}</th>
            <td>{{ parts.name }} {{ showInputText(parts.embroidery) }}</td>
            <td class="price" v-if="parts.price !== 0 && !parts.baseItem">{{ parts.price | formatPrice(item.tax) }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="mirrorPreview__QRarea">
    <div class="mirrorPreview__QRarea__flex">
      <div class="mirrorPreview__QRarea__flex__text">
        <h4 class="mirrorPreview__QRarea__flex__text__title">スマートフォンに保存する</h4>
        <p class="mirrorPreview__QRarea__flex__text__content">左記のQRコードをお手持ちのスマートフォンで読み取って頂くと、カスタムした商品データをスマートフォンに引き継ぐことができ、商品の再カスタマイズや阪急オンラインショップ（E-STORES）でご購入頂くことができます。※E-STORESでご購入できない商品もございます。</p>
      </div>
      <figure class="mirrorPreview__QRarea__flex__QR">
        <figcaption>カスタムID: {{ customItem.customID }}</figcaption>
        <canvas id="QRCode"></canvas>
      </figure>
    </div>
  </div>
  <router-link :to="{ name: 'mirror-custom', query: { customid: customID } }" class="mirrorBackBtn">
    <img src="@/assets/images/mirror/commons/commons-backBtn.svg" alt="Back">
  </router-link>
  <MirrorFooter />
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <BuyInShopModal :customID="customID" v-if="isBuyInShopModal" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
</div>
</template>

<script>
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import MirrorHeader from '@/components/mirror/MirrorHeader'
import MirrorFooter from '@/components/mirror/MirrorFooter'
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import BuyInShopModal from '@/components/mirror/BuyInShopModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import QRCode from 'qrcode'
import {config} from '@/config.js'
import customMgr from '@/modules/CustomManager.js'
import {getDeliveryDateString} from '@/modules/utilityFunctions.js'

Vue.use(VueAwesomeSwiper)

export default {
  mixins: [ScreenSaver],
  components: {
    MirrorHeader,
    MirrorFooter,
    BuyInShopModal,
    MirrorMenuModal,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getCustomItem(String(to.params.customID)).then((customItem) => {
      return customItem
    }).then((customItem) => {
      customMgr.getItem(customItem['id']).then((item) => {
        next(vm => {
          vm.setItem(item)
          vm.setCustomItem(customItem)
        })
      })
    })
  },
  props: {
    customID: String
  },
  data () {
    return {
      customItem: {},
      item: {},
      isTermsModal: false,
      deliveryDate: '',
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      isBuyInShopModal: false,
      isMirrorMenuModal: false
    }
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=1080,user-scalable=no' }
    ]
  },
  computed: {
    basePartsMakerID () {
      if (typeof this.item.parts !== 'undefined') {
        return this.item.parts.find(el => el.baseItem === true).selects[0].makerID
      }
    }
  },
  mounted () {
    const targetURL = config['appURL'] + '/custom?customid=' + this.customID + '&signage=true'
    QRCode.toCanvas(
      this.$el.querySelector('#QRCode'),
      targetURL,
      { errorCorrectionLevel: 'H' },
      (error) => { if (error) console.error(error) }
    )
  },
  methods: {
    setItem (item) {
      this.item = item
    },
    setCustomItem (customItem) {
      this.customItem = customItem
      this.deliveryDate = getDeliveryDateString(this.customItem['parts']) // 納期記述
    },
    showInputText (embroidery) {
      if (typeof embroidery !== 'undefined') {
        return '(' + embroidery['inputText'] + ')'
      }
    },
    buyItem () {
      this.customItem['cartInState'] = true
      this.customItem['cartInDate'] = new Date().getTime()

      customMgr.setCustomItemValue(
        this.customItem['customID'],
        'cartInState', this.customItem['cartInState'])
        .then(
          customMgr.setCustomItemValue(this.customItem['customID'],
            'cartInDate',
            this.customItem['cartInDate']))
        .then(() => {
          this.isBuyInShopModal = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.mirrorPreview {
  &.is-modal {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  &__brand {
    @include headerBrandLogo;
  }
  &__wrap {
    padding: 50px 100px 80px;
    &__swiper {
      &__slide {
        padding: 0 100px;
        &__imgwrap {
          padding: 0 50px;
        }
      }
      .swiper-button-prev,
      .swiper-container-rtl
      .swiper-button-next {
        background-image: none;
      }
      .swiper-button-next,
      .swiper-container-rtl
      .swiper-button-prev {
        background-image: none;
      }
      .swiper-button-prev,
      .swiper-button-next {
        width: 80px;
        height: 80px;
        margin-top: -40px;
      }
      .swiper-button-prev {
        left: 0;
      }
      .swiper-button-next {
        right: 0;
      }
    }
    &__startbtn {
      display: block;
      margin: 50px 0 0 0;
      padding: 35px 0;
      background-color: $blue;
      color: $base-white;
      text-align: center;
      font-size: 28px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 30px;
        width: 40px;
        height: 40px;
        background: url('../../assets/images/mirror/preview/preview-cart.svg') top left no-repeat;
        background-size: 40px 40px;
        margin-top: -20px;
      }
    }
    &__name {
      margin: 40px 0 0 0;
      font-size: 40px;
      font-weight: bold;
      line-height: 1.5;
    }
    &__makerID {
      margin: 10px 0 0 0;
      font-size: 20px;
    }
    &__price {
      margin: 20px 0 0 0;
      font-size: 40px;
      font-weight: bold;
      text-align: right;
      line-height: 1.5;
    }
    &__flex {
      margin: 50px 0 0 0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      &__box {
        width: 48%;
        line-height: 1.5;
        text-align: left;
        &__title {
          font-size: 30px;
          font-weight: bold;
          border-top: 3px solid $right-gray;
          border-bottom: 2px dotted $right-gray;
          padding: 20px 0;
        }
        &__table {
          width: 100%;
          tr {
            border-bottom: 2px dotted $right-gray;
          }
          th, td {
            padding: 20px 0 20px 20px;
            font-size: 20px;
          }
          th {
            font-weight: bold;
          }
          td.price {
            white-space: nowrap;
          }
        }
      }
    }
  }
  &__QRarea {
    padding: 50px 100px 80px;
    background-color: $dark-gray;
    color: $base-white;
    line-height: 1.5;
    &__flex {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-start;
      &__text {
        width: 100%;
        margin-bottom: 30px;
        &__title {
          font-size: 35px;
          font-weight: bold;
          padding: 20px 0 0 70px;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            width: 60px;
            height: 60px;
            background: url('../../assets/images/mirror/preview/preview-mirror.svg') top left no-repeat;
            background-size: 60px 60px;
            margin-top: -20px;
          }
        }
        &__content {
          margin: 40px 0 0 0;
          font-size: 20px;
        }
      }
      &__QR {
        width: 100%;
        text-align: center;
        margin-bottom: 60px;
        canvas {
          width: 25% !important;
          height: auto !important;
        }
        figcaption {
          margin-bottom: 10px;
          font-size: 20px;
        }
      }
    }
  }
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
  .mirrorBackBtn {
    @include mirrorBackBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorPreview.vue